module.exports = __webpack_public_path__ + "media/images/flags/32/Uruguay-d782bd282ce6c5e8b45ac63b50d4ccef.png";